import { render, staticRenderFns } from "./MedicionIndicadorAvpt.vue?vue&type=template&id=fb33dabe&scoped=true"
import script from "./MedicionIndicadorAvpt.vue?vue&type=script&lang=js"
export * from "./MedicionIndicadorAvpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb33dabe",
  null
  
)

export default component.exports